import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/vercel/path0/apps/web/src/components/providers/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/web/src/style/main.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/style/main.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@15.3.8_@babel+core@7.23.0_react-dom@19.1.3_react@19.1.3_sass@1.69.0/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Open_Sans\",\"arguments\":[{\"subsets\":[\"latin\"],\"weight\":[\"300\",\"400\",\"600\"]}],\"variableName\":\"openSans\"}");
